import axios from 'axios';
import authHeader from './auth-header';

class SecurityService {
  toEncrypt(bodyFormData) {
    return axios.patch(`${process.env.VUE_APP_API_BASE_URL}/api/Feature/Security/CryptoGraphy/ToEncrypt`,
      bodyFormData,
      {
        headers: authHeader() 
      })
      .then(response => {
        return response;
      });
  }
  
  toDecrypt(bodyFormData) {
    return axios.patch(`${process.env.VUE_APP_API_BASE_URL}/api/Feature/Security/CryptoGraphy/ToDecrypt`,
      bodyFormData,
      {
        headers: authHeader() 
      })
      .then(response => {
        return response;
      });
  }
}

export default new SecurityService();